import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import AddFromLibraryModal from './add-from-library.modal';

export default function AddFromLibrary({
  offset,
  duration,
  setSelectedSlot,
  isUntimed = false,
  insertBeforeSlotId,
}: {
  offset: number;
  duration?: number;
  setSelectedSlot: (slot?: FlowSlotDto) => void;
  isUntimed?: boolean;
  insertBeforeSlotId?: string;
}) {
  return (
    <AddFromLibraryModal
      offset={offset}
      duration={duration}
      setSelectedSlot={setSelectedSlot}
      isUntimed={isUntimed}
      insertBeforeSlotId={insertBeforeSlotId}
    />
  );
}
